export class NativeStreamVariantShreddingConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "sampleRows",
            "baseName": "sampleRows",
            "type": "number",
            "format": ""
        },
        {
            "name": "registerMinFraction",
            "baseName": "registerMinFraction",
            "type": "number",
            "format": "double"
        },
        {
            "name": "maxDepth",
            "baseName": "maxDepth",
            "type": "number",
            "format": ""
        },
        {
            "name": "maxLeaves",
            "baseName": "maxLeaves",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamVariantShreddingConfig.attributeTypeMap;
    }
    constructor() {
    }
}
